app.directive("listLoader",function($timeout){
     
        
   return {
       restrction:"E",
       scope:{
           
            show:"="
       },
       templateUrl:"/assets/js/angular/components/directives/listloader/loader.html",
       link:function(scope,element){
           
           scope.$watch("show",function(val){
               var el=element.find("div");
               if (val){
                   
                   el.css("display","block");
                   el.addClass("fadeIn");
                   
                }
                else{
                   element.find("div").addClass("fadeOut");
                    
                   $timeout(function(){
                       
                       
                    el.css("display","none");
                   
                       
                   },1000);
               }
           });
           
       }
       
   };     
        
        
});


